export {default as add} from './add.svg';
export {default as alert} from './alert.svg';
export {default as arrowDown} from './arrow-down.svg';
export {default as arrowLeft} from './arrow-left.svg';
export {default as arrowRight} from './arrow-right.svg';
export {default as arrowUp} from './arrow-up.svg';
export {default as arrowUpDown} from './arrow-up-down.svg';
export {default as calendar} from './calendar.svg';
export {default as cancel} from './cancel.svg';
export {default as cancelSmall} from './cancel-small.svg';
export {default as caretDown} from './caret-down.svg';
export {default as caretUp} from './caret-up.svg';
export {default as checkmark} from './checkmark.svg';
export {default as chevronDown} from './chevron-down.svg';
export {default as chevronLeft} from './chevron-left.svg';
export {default as chevronRight} from './chevron-right.svg';
export {default as chevronUp} from './chevron-up.svg';
export {default as circleCancel} from './circle-cancel.svg';
export {default as circleChevronDown} from './circle-chevron-down.svg';
export {default as circleChevronLeft} from './circle-chevron-left.svg';
export {default as circleChevronRight} from './circle-chevron-right.svg';
export {default as circleChevronUp} from './circle-chevron-up.svg';
export {default as circlePlus} from './circle-plus.svg';
export {default as conversation} from './conversation.svg';
export {default as delete} from './delete.svg';
export {default as disable} from './disable.svg';
export {default as dispute} from './dispute.svg';
export {default as duplicate} from './duplicate.svg';
export {default as embed} from './embed.svg';
export {default as export} from './export.svg';
export {default as external} from './external.svg';
export {default as help} from './help.svg';
export {default as horizontalDots} from './horizontal-dots.svg';
export {default as import} from './import.svg';
export {default as notes} from './notes.svg';
export {default as print} from './print.svg';
export {default as refresh} from './refresh.svg';
export {default as risk} from './risk.svg';
export {default as save} from './save.svg';
export {default as search} from './search.svg';
export {default as subtract} from './subtract.svg';
export {default as view} from './view.svg';



// WEBPACK FOOTER //
// ./src/resources/icons/index.js